module.exports = __webpack_public_path__ + "img/logo_white.70b67070.png";